import { useTranslation } from 'react-i18next';

import dayjs from 'dayjs';

import { NotificationItemProps } from 'types/api/notification.type';

import { routes } from 'data/routes';

import { formatSeasonLabel } from 'helpers/formatSeason';

import { Button } from 'components/Button';
import { Headline } from 'components/Headline';
import { Icon } from 'components/Icon';

import * as S from './NotificationItem.styles';

export function NotificationItem(props: NotificationItemProps): React.ReactElement {
  const {
    id,
    englishTitle,
    italianTitle,
    createdAt,
    italianShortDescription,
    englishShortDescription,
    season,
    seasonLine,
    status,
  } = props;
  const { i18n, t } = useTranslation();
  const lang = i18n.language;

  return (
    <S.Container>
      <S.Info>
        <S.Header>
          <S.IconWrapper>
            <Icon
              fontSize={24}
              name={status === 'READ' ? 'BsEnvelopeOpen' : 'BsEnvelopeFill'}
              color="#1badf8"
            />
          </S.IconWrapper>

          <Button
            asLink
            to={routes.notificationsDetails(id)}
            scale="xl"
            whiteSpace="normal"
            motive="productTitle"
          >
            {lang === 'it' ? italianTitle : englishTitle}
          </Button>
        </S.Header>

        <S.Wrapper>
          {createdAt ? (
            <S.FlexItem>
              <Icon fontSize={11} name="FiCalendar" />

              <Headline scale="s" color="grayLabel">
                {dayjs(createdAt).format('DD/MM/YYYY')}
              </Headline>
            </S.FlexItem>
          ) : null}

          {season ? (
            <S.FlexItem>
              <Headline scale="s" color="grayLabel">
                {formatSeasonLabel(season)}
              </Headline>
            </S.FlexItem>
          ) : undefined}

          {seasonLine ? (
            <S.FlexItem>
              <Headline scale="s" color="grayLabel">
                {seasonLine}
              </Headline>
            </S.FlexItem>
          ) : undefined}
        </S.Wrapper>

        <S.Desc>
          <Headline fontFamily="LFT Zeno" scale="s" fontWeight="light" isWrapped={true}>
            {lang === 'it' ? italianShortDescription : englishShortDescription}
          </Headline>
        </S.Desc>
      </S.Info>

      <S.CTA>
        <Button
          asLink
          to={routes.notificationsDetails(id)}
          aria-label={t('notification.read')}
          fontFamily="LFT Zeno"
          scale="xs"
          motive="actionTertiary"
        >
          {t('notification.read')}
        </Button>
      </S.CTA>
    </S.Container>
  );
}
